// extracted by css-extract-rspack-plugin
export default {"Flash":"BlameBanners-module__Flash___ifEP","Box":"BlameBanners-module__Box__Qb4ov"};